import { render, staticRenderFns } from "./RecipeIngredients.vue?vue&type=template&id=4b48d5af&scoped=true&"
import script from "./RecipeIngredients.vue?vue&type=script&lang=js&"
export * from "./RecipeIngredients.vue?vue&type=script&lang=js&"
import style0 from "./RecipeIngredients.vue?vue&type=style&index=0&id=4b48d5af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48d5af",
  null
  
)

export default component.exports